document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  // Animate heading by character
  const hero = document.querySelector("h2.heading-style-display.text-color-secondary:not(.is-discover)");
  if (hero) {
    const split = new SplitType(hero, { types: "chars" });
    gsap.from(split.chars, {
      opacity: 0,
      y: 30,
      stagger: 0.03,
      duration: 0.7,
      ease: "power2.out"
    });
  }

  // Animate ONLY quote h2s with .is-discover that are inside .layout_large-quote
  document.querySelectorAll('.layout_large-quote .heading-style-display.text-color-secondary.is-discover, .layout_large-quote .heading-style-display.text-color-secondary.is-discover.margin-0, .layout_large-quote .heading-style-display.text-color-secondary.is-discover.is-last')
    .forEach(quote => {
      const split = new SplitType(quote, { types: "lines" });
      gsap.from(split.lines, {
        scrollTrigger: {
          trigger: quote,
          start: "top 80%",
        },
        yPercent: 100,
        opacity: 0,
        stagger: 0.1,
        ease: "sine.out",
        duration: 1
      });
    });

  // Mohit/Aneet images and names: target all screen sizes (mobile and desktop)
  document.querySelectorAll(".mohit-image").forEach(el => {
    gsap.from(el, {
      rotation: -20.5, // 30% less than -45
      transformOrigin: "bottom left",
      scrollTrigger: {
        trigger: el,
        start: "top 80%",
        scrub: true
      },
      ease: "sine.out"
    });
  });

  document.querySelectorAll(".mohit-name").forEach(el => {
    gsap.fromTo(el, { y: "-3rem" }, {
      y: "2rem",
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        scrub: true
      },
      ease: "sine.out"
    });
  });

  document.querySelectorAll(".mohit-aneet").forEach(el => {
    gsap.fromTo(el, { y: "3rem" }, {
      y: "-1rem",
      scrollTrigger: {
        trigger: el,
        start: "top 90%",
        scrub: true
      },
      ease: "sine.out"
    });
  });

const isMobile = window.matchMedia("(max-width: 767px)").matches;

document.querySelectorAll(".is-diamon").forEach(el => {
  gsap.from(el, {
    x: isMobile ? -60 : 0,
    y: isMobile ? 0 : 50,
    scrollTrigger: {
      trigger: el,
      start: "top 90%",
      scrub: true
    },
    ease: "sine.out"
  });
});

document.querySelectorAll(".is-oval").forEach(el => {
  gsap.from(el, {
    x: isMobile ? 60 : 0,
    y: isMobile ? 0 : -50,
    scrollTrigger: {
      trigger: el,
      start: "top 90%",
      scrub: true
    },
    ease: "sine.out"
  });
});

document.querySelectorAll(".is-hand").forEach(el => {
  gsap.from(el, {
    x: isMobile ? (Math.random() > 0.5 ? -60 : 60) : 0,
    y: isMobile ? 0 : 50,
    scrollTrigger: {
      trigger: el,
      start: "top 90%",
      scrub: true
    },
    ease: "sine.out"
  });
});


// "Pour and rotate apart" animation for is-bottle and is-hand
document.querySelectorAll(".about_image-wrapper").forEach(wrapper => {
  const bottle = wrapper.querySelector(".is-bottle");
  const hand = wrapper.querySelector(".is-hand");

  if (bottle && hand) {
    gsap.set(bottle, {
      x: 0,
      y: 0,
      scale: 0.93,
      rotation: 28,
      opacity: 0.95,
      zIndex: 2
    });
    gsap.set(hand, {
      x: 0,
      y: 0,
      scale: 0.93,
      rotation: 0,
      opacity: 0.95,
      zIndex: 1
    });

    gsap.timeline({
      scrollTrigger: {
        trigger: wrapper,
        start: "top 70%",
        end: "bottom 20%",
        scrub: true
      }
    })
    .to(bottle, {
      x: -24,
      y: -12,
      rotation: -6,
      scale: 1,
      opacity: 1,
      ease: "back.out(1.7)"
    }, 0)
    .to(hand, {
      x: 40,
      y: 0,
      rotation: 12,
      scale: 1,
      opacity: 1,
      ease: "back.out(1.7)"
    }, 0);
  }
});


// Tiger: delayed fade in from below, then gentle, big bob
const tiger = document.querySelector(".illo_tiger");
if (tiger) {
  gsap.fromTo(
    tiger,
    { opacity: 0, y: 70 },
    {
      opacity: 1,
      y: 0,
      delay: 0.8,
      duration: 1.2,
      ease: "sine.outt",
      onComplete: () => {
        // Gentle, large, slow bob (38px, 2.6s, soft ease)
        gsap.to(tiger, {
          y: 38,
          duration: 2.6,
          ease: "sine.inOut",
          yoyo: true,
          repeat: -1
        });
      }
    }
  );
}


  // illo_lotus - left to right, less movement and/or over longer scroll
  document.querySelectorAll(".illo_lotus").forEach(el => {
    gsap.fromTo(el, { x: -50 }, {
      x: 30,
      scrollTrigger: {
        trigger: el,
        start: "top 80%",
        end: "bottom 0%",
        scrub: true
      },
      ease: "sine.inOut"
    });
  });

  // illo_mango (leftward move and rotate)
  document.querySelectorAll(".illo_mango").forEach(el => {
    gsap.to(el, {
      x: "-40px",
      rotation: -10,
      scrollTrigger: {
        trigger: el,
        start: "top 80%",
        scrub: true
      },
      ease: "sine.out"
    });
  });

  // is-still mask reveal on scroll of parent, slower and delayed
  document.querySelectorAll(".is-still").forEach(el => {
    gsap.from(el, {
      clipPath: "inset(100% 0% 0% 0%)",
      scrollTrigger: {
        trigger: el.closest(".about_image-wrapper") || el,
        start: "top 80%",
      },
      delay: 0.3,
      duration: 1.5,
      ease: "sine.out"
    });
  });

  // Award spins forever (not on scroll)
  document.querySelectorAll(".illo_aaward").forEach(el => {
    gsap.to(el, {
      rotation: 360,
      duration: 12,
      repeat: -1,
      ease: "linear",
      transformOrigin: "50% 50%"
    });
  });

  // illo_signature mask left to right
  document.querySelectorAll(".illo_signature").forEach(el => {
    gsap.from(el, {
      clipPath: "inset(0% 100% 0% 0%)",
      scrollTrigger: {
        trigger: el,
        start: "top 85%"
      },
      duration: 1.2,
      ease: "sine.out"
    });
  });
});